let values = {}
let entities = {}
export const gameStorage = {
  get,
  set,
  all,
  getEntities,
  setEntities,
}
function  all(){
  console.dir(values) // eslint-disable-line
}

function getEntities(name) {
  return entities[name]
}

function setEntities( value, name) {
  if(name === undefined || value === undefined) {
    return
  }
  entities[name] = value
}

function get(name) {
  return values[name]
}

function set( value, name) {
  if(name === undefined || value === undefined) {
    return
  }
  values[name] = value
}
